import React from 'react';
import { trackWhatsAppClick } from '../lib/xTracking';
import { ArrowRight, Network, Handshake, Lock } from 'lucide-react';

export default function Hero() {
  return (
    <section id="top" className="relative bg-dot-pattern">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-24 left-1/2 -translate-x-1/2 h-[560px] w-[920px] rounded-full blur-3xl" style={{ background: 'radial-gradient(closest-side, rgba(0,0,0,0.05), transparent 70%)' }} />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 pt-28 md:pt-36 pb-20 md:pb-28 text-center">
        <h1 className="font-display-bold text-[46px] leading-[1.02] md:text-[96px] md:leading-[0.98] text-neutral-900 animate-fade-up">
          Your Partner for
          <br />
          <span className="relative inline-block">
            <span className="relative z-10">Complex Matters</span>
            <span className="absolute -inset-x-2 bottom-2 md:bottom-3 h-3 md:h-5 -z-0 rounded-md bg-[#E8DBC6]" />
          </span>
        </h1>

        <p className="mt-8 md:mt-12 max-w-4xl mx-auto text-xl md:text-2xl leading-relaxed text-neutral-700 animate-fade-up animate-delay-1">
          For <span className="font-semibold text-neutral-900">Private clients</span> and <span className="font-semibold text-neutral-900">Businesses</span> who need a trusted partner to navigate <span className="font-semibold text-neutral-900">Government, Land, Capital and Special Situations</span>.
        </p>

        <div className="mt-10 md:mt-14 flex flex-col sm:flex-row items-center justify-center gap-3 animate-fade-up animate-delay-2">
          <a
            href="https://wa.me/918976171100"
            onClick={trackWhatsAppClick}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-primary btn-shimmer inline-flex items-center gap-3 bg-neutral-900 text-white text-base md:text-lg font-medium px-8 md:px-10 py-5 md:py-6 rounded-full"
          >
            Get in Touch
            <ArrowRight className="h-5 w-5" />
          </a>
          <a
            href="https://calendly.com/contact-onecatalyst/30min"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-outline inline-flex items-center gap-3 bg-white text-neutral-900 border border-neutral-900 text-base md:text-lg font-medium px-8 md:px-10 py-5 md:py-6 rounded-full"
          >
            Schedule a Call
          </a>
        </div>

        <div className="mt-16 md:mt-24 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 text-left">
          {[{
            icon: Network,
            title: 'Presence in 20+ States',
            desc: 'The right people, across India, when you need them.',
          }, {
            icon: Handshake,
            title: 'Across Sectors & Situations',
            desc: 'Relationships spanning business, capital, government and private networks.',
          }, {
            icon: Lock,
            title: 'Confidential by Design',
            desc: 'What you share with us stays private.',
          }].map((p) => {
            const Icon = p.icon;
            return (
              <div key={p.title} className="card-hover bg-white border border-neutral-200 rounded-[24px] p-7 md:p-8">
                <div className="h-14 w-14 rounded-2xl flex items-center justify-center bg-neutral-50 border border-neutral-200">
                  <Icon className="h-7 w-7 text-neutral-900" strokeWidth={1.75} />
                </div>
                <div className="mt-6 font-display-bold text-xl md:text-[22px] leading-tight text-neutral-900">{p.title}</div>
                <div className="mt-2 text-[14px] leading-relaxed text-neutral-600">{p.desc}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
